<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <toolbar ref="toolbar" :key="toolbarKey" :buttonList="buttonList" @callFunction="callFunction"
        :searchList="searchList"></toolbar>

      <div class="tbl-scroll-host">
      <el-table :data="tableData" v-loading="listLoading" @row-click="showDetail" ref="table"
        class="custom-tbl" style="width: 100%;" :row-style="{ cursor: 'pointer' }" height="100%">
        <el-table-column prop="FaultTypeName" label="故障类型" width="100"></el-table-column>
        <el-table-column prop="Location" label="故障地点" min-width="120"></el-table-column>
        <el-table-column prop="Description" label="故障描述" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ApplicantTeacherName" label="发起人" width="90"></el-table-column>
        <el-table-column prop="AssignedRepairerName" label="维修人员" width="90">
          <template slot-scope="scope">{{ scope.row.AssignedRepairerName || '-' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.Status)" size="small">{{ scope.row.StatusStr }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="预估金额" width="100" align="right">
          <template slot-scope="scope">
            <span v-if="scope.row.EstimatedAmount">¥ {{ scope.row.EstimatedAmount.toFixed(2) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="DepartmentName" label="学校" width="120"></el-table-column>
        <el-table-column prop="CreateTime" label="提交时间" width="165"></el-table-column>
        <el-table-column prop="CompleteTime" label="完成时间" width="165">
          <template slot-scope="scope">{{ scope.row.CompleteTime || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-document"
              :loading="pdfExportingId === scope.row.Id"
              :disabled="!!pdfExportingId && pdfExportingId !== scope.row.Id"
              @click.stop="handleExportPdf(scope.row)">
              导出PDF
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="pageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!--报修单详情弹窗-->
      <el-dialog
        title="报修单详情"
        :visible.sync="detailVisible"
        width="720px"
        top="5vh"
        append-to-body
        @closed="onDetailClosed">
        <div v-if="detailLoading" v-loading="true" class="repair-detail-loading"></div>
        <template v-else-if="detailData">
          <div class="repair-summary">
            <span class="repair-summary__type">{{ detailData.request.FaultTypeName }}</span>
            <span class="repair-summary__loc">{{ detailData.request.Location }}</span>
            <el-tag :type="getStatusTagType(detailData.request.Status)" size="small">
              {{ detailData.request.StatusStr }}
            </el-tag>
          </div>

          <el-steps :active="repairFlowActive" finish-status="success" align-center class="repair-flow-steps" simple>
            <el-step title="报修" />
            <el-step :title="isVocationalMode ? '初审' : '派单'" :description="isVocationalMode ? '含派单/报价' : ''" />
            <el-step title="费用" />
            <el-step title="完工" />
          </el-steps>

          <el-descriptions :column="2" border size="small" class="repair-meta-desc">
            <el-descriptions-item label="流程模式">{{ workflowModeStr }}</el-descriptions-item>
            <el-descriptions-item label="发起人">{{ detailData.request.ApplicantTeacherName }}</el-descriptions-item>
            <el-descriptions-item label="维修人员">{{ detailData.request.AssignedRepairerName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="是否有费用">
              <span v-if="detailData.request.HasCost === true" class="text-warning">有费用</span>
              <span v-else-if="detailData.request.HasCost === false" class="text-success">无费用</span>
              <span v-else class="text-muted">未检测</span>
            </el-descriptions-item>
            <el-descriptions-item label="提交时间">{{ detailData.request.CreateTime }}</el-descriptions-item>
            <el-descriptions-item label="完成时间" :span="2">{{ detailData.request.CompleteTime || '-' }}</el-descriptions-item>
          </el-descriptions>

          <el-tabs v-model="detailActiveTab" class="repair-detail-tabs">
            <el-tab-pane label="报修信息" name="fault" lazy>
              <el-descriptions :column="1" border size="small">
                <el-descriptions-item label="故障描述">{{ detailData.request.Description || '-' }}</el-descriptions-item>
              </el-descriptions>
              <el-alert
                v-if="detailData.request.RejectReason"
                :title="'驳回原因：' + detailData.request.RejectReason"
                type="error"
                :closable="false"
                show-icon
                class="repair-reject-alert" />
              <div v-if="faultImageList.length" class="repair-block">
                <div class="repair-block__title">故障照片</div>
                <div class="repair-img-list">
                  <oss-el-image
                    v-for="(url, i) in faultImageList"
                    :key="'f-' + i"
                    :src="url"
                    :school-id="detailSchoolId"
                    :preview-src-list="faultImageList"
                    class="repair-img-item"
                    fit="cover" />
                </div>
              </div>
              <div v-else class="repair-detail-empty">暂无故障照片</div>
            </el-tab-pane>

            <el-tab-pane
              :label="processTabLabel"
              name="process"
              lazy>
              <div class="repair-process-tab-hd">
                <span class="repair-process-count">共 {{ processMediaList.length }} 条记录</span>
                <el-button
                  v-if="canUploadProcessMedia"
                  type="primary"
                  size="mini"
                  icon="el-icon-plus"
                  @click="openProcessUpload">
                  补充过程记录
                </el-button>
                <el-tag v-else size="mini" type="info" effect="plain">
                  已结单（不可追加）
                </el-tag>
              </div>

              <div v-if="processMediaList.length" class="repair-process-timeline-wrap">
                <el-timeline class="repair-timeline">
                  <el-timeline-item
                    v-for="(item, idx) in processMediaList"
                    :key="'pm-' + (item.Id || idx)"
                    :timestamp="item.CreateTime"
                    placement="top">
                    <el-card shadow="never" class="repair-process-card">
                      <div class="repair-process-meta">
                        <span class="repair-process-author">{{ item.UploaderName }}</span>
                        <el-tag :type="getProcessRoleTagType(item.UploaderRole)" size="mini" effect="light">
                          {{ item.UploaderRoleName || getProcessRoleName(item.UploaderRole) }}
                        </el-tag>
                      </div>
                      <p v-if="item.Description" class="repair-process-desc">{{ item.Description }}</p>
                      <div v-if="item.MediaUrlList && item.MediaUrlList.length" class="repair-img-list">
                        <oss-el-image
                          v-for="(url, i) in item.MediaUrlList"
                          :key="'pmi-' + i"
                          :src="url"
                          :school-id="detailSchoolId"
                          :preview-src-list="item.MediaUrlList"
                          class="repair-img-item"
                          fit="cover" />
                      </div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </div>
              <div v-else class="repair-detail-empty">
                {{ canUploadProcessMedia ? '暂无过程记录，点击上方「补充过程记录」可上传现场照片' : '该报修单施工期间未上传过程照片' }}
              </div>
            </el-tab-pane>

            <el-tab-pane
              v-if="detailData.dispatches && detailData.dispatches.length"
              label="派单记录"
              name="dispatch"
              lazy>
              <el-table :data="detailData.dispatches" size="mini" border class="repair-dispatch-table">
                <el-table-column prop="RepairerName" label="维修师傅" width="100" />
                <el-table-column label="派单方式" width="110">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.DispatchSource === 'manual' ? 'warning' : 'info'" size="mini">
                      {{ scope.row.DispatchSourceStr || getDispatchSourceStr(scope.row.DispatchSource) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="状态" width="80">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.IsActive ? 'success' : 'info'" size="mini">
                      {{ scope.row.IsActive ? '有效' : '历史' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="DispatchedByName" label="指派人" width="90">
                  <template slot-scope="scope">{{ scope.row.DispatchedByName || '-' }}</template>
                </el-table-column>
                <el-table-column prop="DispatchTime" label="派单时间" min-width="150" />
              </el-table>
            </el-tab-pane>

            <el-tab-pane v-if="detailData.costQuote" label="费用报价" name="cost" lazy>
              <el-descriptions :column="2" border size="small">
                <el-descriptions-item label="预估金额">
                  <span class="text-warning">¥ {{ formatAmount(detailData.costQuote.EstimatedAmount) }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="提交时间">{{ detailData.costQuote.SubmitTime }}</el-descriptions-item>
                <el-descriptions-item v-if="hasCostQuoteDuration" label="预计工期">
                  {{ formatDurationDays(detailData.costQuote.EstimatedDurationDays) }} 天
                </el-descriptions-item>
                <el-descriptions-item v-if="detailData.costQuote.SubmitRole" label="提交角色">
                  {{ getSubmitRoleStr(detailData.costQuote.SubmitRole) }}
                </el-descriptions-item>
                <el-descriptions-item v-if="detailData.costQuote.FaultTypeName" label="维修类型" :span="2">
                  {{ detailData.costQuote.FaultTypeName }}
                </el-descriptions-item>
                <el-descriptions-item v-if="detailData.costQuote.RepairerName" label="指定维修人" :span="2">
                  {{ detailData.costQuote.RepairerName }}
                </el-descriptions-item>
                <el-descriptions-item v-if="hasManpowerInfo" label="人工配置" :span="2">
                  {{ formatManpowerSummary(detailData.costQuote) }}
                </el-descriptions-item>
                <el-descriptions-item label="物料清单" :span="2">
                  <span
                    class="repair-material-text"
                    :class="{ 'is-expanded': costMaterialExpanded }"
                    :title="detailData.costQuote.MaterialDescription">
                    {{ detailData.costQuote.MaterialDescription || '-' }}
                  </span>
                  <el-button
                    v-if="isCostMaterialLong"
                    type="text"
                    size="mini"
                    class="repair-material-toggle"
                    @click="costMaterialExpanded = !costMaterialExpanded">
                    {{ costMaterialExpanded ? '收起' : '展开' }}
                  </el-button>
                </el-descriptions-item>
              </el-descriptions>
              <div v-if="costImageList.length" class="repair-block">
                <div class="repair-block__title">报价照片</div>
                <div class="repair-img-list">
                  <oss-el-image
                    v-for="(url, i) in costImageList"
                    :key="'c-' + i"
                    :src="url"
                    :school-id="detailSchoolId"
                    :preview-src-list="costImageList"
                    class="repair-img-item"
                    fit="cover" />
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane v-if="detailData.repairResult" label="维修结果" name="result" lazy>
              <el-descriptions :column="2" border size="small">
                <el-descriptions-item label="维修师傅">{{ detailData.repairResult.SubmitByName }}</el-descriptions-item>
                <el-descriptions-item label="完成时间">{{ detailData.repairResult.CompleteTime }}</el-descriptions-item>
                <el-descriptions-item label="结果描述" :span="2">
                  {{ detailData.repairResult.ResultDescription || '-' }}
                </el-descriptions-item>
              </el-descriptions>
              <div v-if="resultMediaList.length" class="repair-block">
                <div class="repair-block__title">结果照片</div>
                <div class="repair-img-list">
                  <oss-el-image
                    v-for="(url, i) in resultMediaList"
                    :key="'r-' + i"
                    :src="url"
                    :school-id="detailSchoolId"
                    :preview-src-list="resultMediaList"
                    class="repair-img-item"
                    fit="cover" />
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane
              v-if="detailData.steps && detailData.steps.length"
              label="审批流程"
              name="approval"
              lazy>
              <el-timeline class="repair-timeline">
                <el-timeline-item
                  v-for="step in detailData.steps"
                  :key="step.StepNumber + step.ApproverName + step.Phase"
                  :type="getStepType(step.Status)"
                  :timestamp="step.ApprovedAt || ''"
                  placement="top">
                  <div class="repair-step-line">
                    <el-tag size="mini" effect="plain" type="info">
                      {{ step.Phase === 'general_affairs' ? '初审' : '费用审批' }}
                    </el-tag>
                    <span>第 {{ step.StepNumber }} 步 · {{ step.ApproverName }}</span>
                    <el-tag :type="getStepTagType(step.Status)" size="mini">{{ getStepStatusStr(step.Status) }}</el-tag>
                  </div>
                  <p v-if="step.Comments" class="repair-step-comment">意见：{{ step.Comments }}</p>
                </el-timeline-item>
              </el-timeline>
            </el-tab-pane>
          </el-tabs>
        </template>
        <div v-if="detailData && !detailLoading" slot="footer">
          <el-button
            v-if="detailData.request.Status === 1 && !detailData.request.AssignedRepairerName"
            type="primary"
            size="small"
            @click="openDispatch">
            手动指派师傅
          </el-button>
          <el-button
            size="small"
            icon="el-icon-document"
            :loading="pdfExportingId === detailData.request.Id"
            :disabled="!!pdfExportingId && pdfExportingId !== detailData.request.Id"
            @click="handleExportPdf(detailData.request)">
            导出PDF
          </el-button>
          <el-button size="small" @click="closeDetail">关闭</el-button>
        </div>
      </el-dialog>

      <!--手动指派师傅弹窗-->
      <el-dialog title="手动指派维修师傅" :visible.sync="dispatchVisible" width="460px"
        :close-on-click-modal="false" append-to-body>
        <el-form :model="dispatchForm" label-width="90px" size="small">
          <el-form-item label="选择师傅" required>
            <el-select
              v-model="dispatchForm.repairerMasterId"
              filterable
              remote
              placeholder="输入姓名搜索教职工"
              :remote-method="searchTeachers"
              :loading="dispatchSearching"
              style="width: 100%;">
              <el-option
                v-for="t in dispatchTeacherOptions"
                :key="t.Id"
                :label="t.TeacherName"
                :value="t.Id">
                <span>{{ t.TeacherName }}</span>
                <span style="color: #8492a6; font-size: 12px; margin-left: 8px;">{{ t.JobNo }}</span>
              </el-option>
            </el-select>
            <div style="font-size: 12px; color: #909399; margin-top: 4px;">
              注：该故障类型未绑定维修师傅，请手动选择
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dispatchVisible = false">取消</el-button>
          <el-button type="primary" :loading="dispatchSubmitting" @click="submitDispatch">确认指派</el-button>
        </div>
      </el-dialog>

      <!--PC 补充维修过程记录弹窗-->
      <el-dialog
        title="补充维修过程记录"
        :visible.sync="processUploadVisible"
        width="540px"
        append-to-body
        :close-on-click-modal="false"
        @closed="resetProcessUpload">
        <el-form label-position="top" size="small">
          <el-form-item label="过程照片（最多 9 张）" required>
            <el-upload
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :file-list="processFileList"
              :limit="9"
              :on-change="handleProcessFileChange"
              :on-remove="handleProcessFileRemove"
              :on-exceed="handleProcessFileExceed"
              accept="image/jpeg,image/png,image/jpg,image/webp">
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="过程文字说明（选填，最多 500 字）">
            <el-input
              v-model="processDescription"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              placeholder="请输入当前维修施工进度、更换备件或现场踏勘情况..." />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button size="small" :disabled="processSubmitting" @click="processUploadVisible = false">取消</el-button>
          <el-button type="primary" size="small" :loading="processSubmitting" @click="submitProcessUpload">确定上传</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import {
  getRepairRequestListPage,
  getRepairRequestDetail,
  getRepairFaultTypeList,
  manualDispatchRepair,
  uploadRepairProcessMedia,
  exportRepairRequestList,
  exportRepairRequestPdf
} from '../../api/modules/repair';
import { getTeacherMasterListPage } from '../../api/modules/personnel';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';
import OssElImage from '../../components/OssElImage.vue';
import { getUploadSchoolId, uploadPic } from '../../utils/ossMediaUpload';

export default {
  components: { Toolbar, DepartmentPane, OssElImage },
  data() {
    return {
      toolbarKey: Date.now(),
      searchList: [
        { label: '发起人', key: 'applicantName', width: '140px' },
        {
          label: '状态',
          key: 'status',
          type: 'select',
          clearable: true,
          initValue: -1,
          width: '140px',
          options: [
            { label: '全部', value: -1 },
            { label: '待初审', value: 0 },
            { label: '待维修', value: 1 },
            { label: '维修处理中', value: 2 },
            { label: '费用审批中', value: 3 },
            { label: '已完成', value: 4 },
            { label: '已驳回', value: 5 },
            { label: '已取消', value: 6 },
            { label: '费用审批驳回', value: 7 }
          ]
        },
        {
          label: '故障类型',
          key: 'faultTypeId',
          type: 'select',
          clearable: true,
          width: '140px',
          options: []
        },
        {
          label: '提交日期',
          key: 'dateRange',
          type: 'daterange',
          init: false,
          width: '240px'
        }
      ],
      filters: {},
      tableData: [],
      total: 0,
      pageSize: 10,
      page: 1,
      listLoading: false,
      exportLoading: false,
      pdfExportingId: null,
      buttonList: [],
      DepartmentId: 0,

      detailVisible: false,
      detailLoading: false,
      detailData: null,
      detailActiveTab: 'fault',
      costMaterialExpanded: false,
      faultImageList: [],
      costImageList: [],
      resultMediaList: [],

      processUploadVisible: false,
      processFileList: [],
      processDescription: '',
      processSubmitting: false,

      dispatchVisible: false,
      dispatchSubmitting: false,
      dispatchSearching: false,
      dispatchTeacherOptions: [],
      dispatchForm: { repairerMasterId: null }
    };
  },

  computed: {
    /** 详情弹窗内 OSS 预签名用学校 ID（优先报修单所属学校） */
    detailSchoolId() {
      const req = this.detailData && this.detailData.request;
      if (req && req.SchoolId) return req.SchoolId;
      if (this.DepartmentId) return this.DepartmentId;
      return getUploadSchoolId(this);
    },

    /** 流程步骤条当前进度（0 报修 1 派单 2 费用 3 完工，4 表示全部完成） */
    repairFlowActive() {
      return this.calcRepairFlowActive();
    },

    /** 物料清单是否过长，需展示展开按钮 */
    isCostMaterialLong() {
      const text = this.detailData && this.detailData.costQuote && this.detailData.costQuote.MaterialDescription;
      return text && String(text).length > 80;
    },

    /** 是否中职模式单据 */
    isVocationalMode() {
      const req = this.detailData && this.detailData.request;
      return req && String(req.WorkflowMode || '').toLowerCase() === 'vocational';
    },

    /** 流程模式中文 */
    workflowModeStr() {
      return this.isVocationalMode ? '中职模式' : '平台模式';
    },

    /** 报价是否含预计工期 */
    hasCostQuoteDuration() {
      const days = this.detailData && this.detailData.costQuote && this.detailData.costQuote.EstimatedDurationDays;
      return days !== null && days !== undefined && days !== '';
    },

    /** 报价是否含人工配置 */
    hasManpowerInfo() {
      const q = this.detailData && this.detailData.costQuote;
      if (!q) return false;
      return [q.ManpowerMason, q.ManpowerGeneral, q.ManpowerUtility, q.ManpowerCarpenter, q.ManpowerHauling]
        .some(v => v !== null && v !== undefined && Number(v) > 0);
    },

    /** 过程记录列表 */
    processMediaList() {
      const list = this.detailData && this.detailData.processMedias;
      return Array.isArray(list) ? list : [];
    },

    /** 是否允许 PC 上传过程记录（未结束状态） */
    canUploadProcessMedia() {
      const req = this.detailData && this.detailData.request;
      if (!req) return false;
      return [0, 1, 2, 3, 7].includes(req.Status);
    },

    /** 过程记录 Tab 标签显示（有记录时附带计数） */
    processTabLabel() {
      const len = this.processMediaList.length;
      return len > 0 ? `过程记录 (${len})` : '过程记录';
    }
  },

  methods: {
    parseImageUrls(raw) {
      if (!raw) return [];
      return String(raw).split(',').map(u => u.trim()).filter(Boolean);
    },

    formatAmount(val) {
      const n = Number(val);
      return Number.isFinite(n) ? n.toFixed(2) : '0.00';
    },

    /**
     * 预计工期天数格式化，最多保留两位小数。最后更新：2026-10-12
     * @param {number|string} days - 后端返回的天数（旧数据已由后端按小时换算）
     * @returns {string}
     */
    formatDurationDays(days) {
      const n = Number(days);
      if (!Number.isFinite(n)) return '-';
      return String(Math.round(n * 100) / 100);
    },

    getSubmitRoleStr(role) {
      if (role === 'first_audit') return '初审老师';
      if (role === 'repairer') return '维修师傅';
      return role || '-';
    },

    formatManpowerSummary(quote) {
      if (!quote) return '-';
      const items = [
        { label: '泥瓦工', value: quote.ManpowerMason },
        { label: '杂工', value: quote.ManpowerGeneral },
        { label: '水电', value: quote.ManpowerUtility },
        { label: '木工', value: quote.ManpowerCarpenter },
        { label: '清运', value: quote.ManpowerHauling }
      ];
      const parts = items
        .filter(i => Number(i.value) > 0)
        .map(i => `${i.label}${i.value}人`);
      return parts.length ? parts.join('、') : '-';
    },

    /** 费用审批阶段是否已全部通过 */
    isCostApprovalPassed() {
      const steps = (this.detailData && this.detailData.steps) || [];
      const costSteps = steps.filter(s => s.Phase !== 'general_affairs');
      if (!costSteps.length) return false;
      return costSteps.every(s => s.Status === 'Approved');
    },

    /**
     * 计算流程步骤条 active 值，结合状态与审批/报价数据。
     * 0 报修 | 1 派单 | 2 费用 | 3 完工 | 4 全部完成
     */
    calcRepairFlowActive() {
      const data = this.detailData;
      const req = data && data.request;
      if (!req) return 0;

      const status = req.Status;
      if (this.isVocationalMode) {
        if (status === 4) return 4;
        if (status === 0 || status === 5 || status === 6) return 0;
        if (status === 3 || status === 7) return 2;
        if (status === 2) return 3;
        if (status === 1) return 1;
        return 0;
      }

      if (status === 4) return 4;
      if (status === 0 || status === 5 || status === 6) return 0;
      if (status === 3 || status === 7) return 2;

      const hasDispatch = !!(data.dispatches && data.dispatches.length);
      const hasCostQuote = !!data.costQuote;
      const noCost = req.HasCost === false;
      const costApprovalDone = this.isCostApprovalPassed();

      if (status === 1) {
        return hasDispatch ? 1 : 0;
      }

      if (status === 2) {
        if (!hasDispatch) return 1;
        if (noCost) return 3;
        if (hasCostQuote && costApprovalDone) return 3;
        if (hasCostQuote) return 2;
        return 2;
      }

      return 0;
    },

    /** 按工单状态与数据决定默认 Tab */
    initDetailActiveTab() {
      const req = (this.detailData && this.detailData.request) || {};
      const status = req.Status;
      let tab = 'fault';
      if (status === 4 && this.detailData.repairResult) {
        tab = 'result';
      } else if (status === 3 && this.detailData.costQuote) {
        tab = 'cost';
      } else if (status === 2 && this.detailData.costQuote && this.isCostApprovalPassed()) {
        tab = 'fault';
      } else if ((status === 1 || status === 2) && this.detailData.dispatches && this.detailData.dispatches.length) {
        tab = 'dispatch';
      }
      if (tab === 'dispatch' && !(this.detailData.dispatches && this.detailData.dispatches.length)) tab = 'fault';
      if (tab === 'cost' && !this.detailData.costQuote) tab = 'fault';
      if (tab === 'result' && !this.detailData.repairResult) tab = 'fault';
      this.detailActiveTab = tab;
    },

    buildFilterParams() {
      const f = this.filters || {};
      return {
        departmentId: this.DepartmentId,
        applicantName: f.applicantName || '',
        status: f.status !== undefined && f.status !== null && f.status !== '' ? f.status : -1,
        faultTypeId: f.faultTypeId || 0,
        startTime: f.dateRange && f.dateRange[0] ? f.dateRange[0] : null,
        endTime: f.dateRange && f.dateRange[1] ? f.dateRange[1] : null
      };
    },

    handleQuery() {
      const para = {
        page: this.page,
        intPageSize: this.pageSize,
        ...this.buildFilterParams()
      };
      this.listLoading = true;
      getRepairRequestListPage(para).then(res => {
        this.listLoading = false;
        if (res.data && res.data.success && res.data.response) {
          this.tableData = res.data.response.data || [];
          this.total = res.data.response.dataCount || 0;
        }
      }).catch(() => { this.listLoading = false; });
    },

    async handleExport() {
      try {
        const res = await exportRepairRequestList(this.buildFilterParams());
        if (!res.data || res.data.size === 0) {
          this.$message.error('导出数据为空');
          return;
        }
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const d = new Date();
        const pad = n => String(n).padStart(2, '0');
        link.setAttribute('download', `报修单列表_${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (e) {
        this.$message.error('导出失败');
      }
    },

    /**
     * 导出单张报修单 PDF（同步生成后直接下载）。创建于 2026-10-12
     * @param {Object} row - 报修单（需含 Id、Location、CreateTime）
     */
    async handleExportPdf(row) {
      if (!row || !row.Id || this.pdfExportingId) return;
      this.pdfExportingId = row.Id;
      try {
        const res = await exportRepairRequestPdf(row.Id);
        const data = res && res.data;
        if (!data || data.size === 0) {
          this.$message.error('导出失败：文件为空');
          return;
        }
        // 后端失败时返回 JSON，需从 blob 中解析错误信息
        if (data.type && data.type.indexOf('application/json') >= 0) {
          const text = await data.text();
          let msg = '导出失败';
          try {
            const json = JSON.parse(text);
            msg = json.msg || msg;
          } catch (e) { /* 非 JSON 内容沿用默认提示 */ }
          this.$message.error(msg);
          return;
        }
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const sanitize = (text, fallback) => String(text || fallback).replace(/[\\/:*?"<>|]/g, '_').slice(0, 30);
        const applicant = sanitize(row.ApplicantTeacherName, '未知发起人');
        const location = sanitize(row.Location, '未填写地点');
        const datePart = String(row.CreateTime || '').slice(0, 10).replace(/-/g, '');
        link.setAttribute('download', `报修单_${applicant}_${location}${datePart ? '_' + datePart : ''}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (e) {
        this.$message.error('导出PDF失败，请稍后重试');
      } finally {
        this.pdfExportingId = null;
      }
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.page = 1;
      this.loadFaultTypes(data.value);
      this.$nextTick(() => {
        if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
          this.$refs.toolbar.searchObj.faultTypeId = '';
        }
        this.handleQuery();
      });
    },

    loadFaultTypes(departmentId) {
      if (!departmentId) {
        this.updateFaultTypeOptions([]);
        return;
      }
      getRepairFaultTypeList({ departmentId }).then(res => {
        if (res.data && res.data.success) {
          const list = res.data.response || [];
          const options = list.map(f => ({ label: f.Name, value: f.Id }));
          this.updateFaultTypeOptions(options);
        }
      });
    },

    updateFaultTypeOptions(options) {
      const idx = this.searchList.findIndex(s => s.key === 'faultTypeId');
      if (idx >= 0) {
        this.$set(this.searchList[idx], 'options', options);
        this.toolbarKey = Date.now();
      }
    },

    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = item.search;
      } else {
        this.filters = { applicantName: item.search };
      }
      if (item.Func && typeof this[item.Func] === 'function') {
        this[item.Func].apply(this, item);
      }
    },

    showDetail(row) {
      if (this.detailVisible) return;
      this.detailVisible = true;
      this.detailData = null;
      this.detailActiveTab = 'fault';
      this.costMaterialExpanded = false;
      this.faultImageList = [];
      this.costImageList = [];
      this.resultMediaList = [];
      this.detailLoading = true;
      getRepairRequestDetail(row.Id).then(res => {
        this.detailLoading = false;
        if (res.data && res.data.success) {
          this.detailData = res.data.response;
          const req = this.detailData.request || {};
          this.faultImageList = this.parseImageUrls(req.FaultImages);
          this.costImageList = this.parseImageUrls(this.detailData.costQuote && this.detailData.costQuote.Images);
          this.resultMediaList = this.parseImageUrls(this.detailData.repairResult && this.detailData.repairResult.MediaUrls);
          this.initDetailActiveTab();
        }
      }).catch(() => { this.detailLoading = false; });
    },

    closeDetail() {
      this.detailVisible = false;
    },

    onDetailClosed() {
      this.detailActiveTab = 'fault';
      this.costMaterialExpanded = false;
      this.detailData = null;
      this.detailLoading = false;
      this.faultImageList = [];
      this.costImageList = [];
      this.resultMediaList = [];
      this.resetProcessUpload();
    },

    getStatusTagType(status) {
      const map = { 0: 'warning', 1: 'info', 2: '', 3: 'warning', 4: 'success', 5: 'danger', 6: 'info', 7: 'danger' };
      return map[status] != null ? map[status] : 'info';
    },

    getStepType(status) {
      return { Approved: 'success', Rejected: 'danger', Cancel: 'info' }[status] || 'primary';
    },

    getStepTagType(status) {
      return { Approved: 'success', Rejected: 'danger', Cancel: 'info', Pending: 'warning' }[status] || '';
    },

    getStepStatusStr(status) {
      return { Approved: '已通过', Rejected: '已驳回', Pending: '待审批', Cancel: '已取消' }[status] || status;
    },

    getDispatchSourceStr(source) {
      if (source === 'manual') return '手动指派';
      if (source === 'first_audit') return '初审指定';
      return '系统自动派单';
    },

    openDispatch() {
      this.dispatchForm = { repairerMasterId: null };
      this.dispatchTeacherOptions = [];
      this.dispatchVisible = true;
    },

    searchTeachers(query) {
      if (!query) return;
      this.dispatchSearching = true;
      getTeacherMasterListPage({ page: 1, intPageSize: 30, name: query, departmentId: this.DepartmentId || '' })
        .then(res => {
          this.dispatchSearching = false;
          if (res.data && res.data.success && res.data.response) {
            this.dispatchTeacherOptions = res.data.response.data || [];
          }
        })
        .catch(() => { this.dispatchSearching = false; });
    },

    submitDispatch() {
      if (!this.dispatchForm.repairerMasterId) {
        this.$message.warning('请选择维修师傅');
        return;
      }
      if (!this.detailData) return;
      this.dispatchSubmitting = true;
      manualDispatchRepair({
        repairRequestId: this.detailData.request.Id,
        repairerMasterId: this.dispatchForm.repairerMasterId
      }).then(res => {
        this.dispatchSubmitting = false;
        if (res.data && res.data.success) {
          this.$message.success('指派成功');
          this.dispatchVisible = false;
          const requestId = this.detailData.request.Id;
          this.detailLoading = true;
          getRepairRequestDetail(requestId).then(detailRes => {
            this.detailLoading = false;
            if (detailRes.data && detailRes.data.success) {
              this.detailData = detailRes.data.response;
              const req = this.detailData.request || {};
              this.faultImageList = this.parseImageUrls(req.FaultImages);
              this.costImageList = this.parseImageUrls(this.detailData.costQuote && this.detailData.costQuote.Images);
              this.resultMediaList = this.parseImageUrls(this.detailData.repairResult && this.detailData.repairResult.MediaUrls);
              this.initDetailActiveTab();
            }
          }).catch(() => { this.detailLoading = false; });
          this.handleQuery();
        } else {
          this.$message.error(res.data.msg || '指派失败');
        }
      }).catch(() => {
        this.dispatchSubmitting = false;
        this.$message.error('请求异常');
      });
    },

    getProcessRoleTagType(role) {
      switch (role) {
        case 'repairer': return 'success';
        case 'applicant': return 'info';
        case 'approver': return 'warning';
        case 'admin': return 'danger';
        default: return '';
      }
    },

    getProcessRoleName(role) {
      const map = { applicant: '发起人', repairer: '维修师傅', approver: '审批人员', admin: '报修管理员' };
      return map[role] || '流程经办人';
    },

    openProcessUpload() {
      this.resetProcessUpload();
      this.processUploadVisible = true;
    },

    resetProcessUpload() {
      this.processFileList = [];
      this.processDescription = '';
      this.processSubmitting = false;
    },

    handleProcessFileChange(file, fileList) {
      this.processFileList = fileList;
    },

    handleProcessFileRemove(file, fileList) {
      this.processFileList = fileList;
    },

    handleProcessFileExceed() {
      this.$message.warning('单次最多上传 9 张照片');
    },

    async submitProcessUpload() {
      if (!this.processFileList.length) {
        this.$message.warning('请至少选择一张过程照片');
        return;
      }
      this.processSubmitting = true;
      try {
        const uploadedUrls = [];
        for (const f of this.processFileList) {
          if (f.url && f.url.startsWith('http') && !f.raw) {
            uploadedUrls.push(f.url);
          } else if (f.raw) {
            const { url } = await uploadPic(f.raw, this, 'repair_process');
            if (url) uploadedUrls.push(url);
          }
        }
        if (!uploadedUrls.length) {
          this.$message.warning('图片上传处理失败，请重试');
          this.processSubmitting = false;
          return;
        }
        const reqId = this.detailData.request.Id;
        const res = await uploadRepairProcessMedia({
          RepairRequestId: reqId,
          MediaUrls: uploadedUrls.join(','),
          Description: this.processDescription
        });
        if (res.data && res.data.success) {
          this.$message.success('过程记录上传成功');
          this.processUploadVisible = false;
          this.resetProcessUpload();
          // 刷新详情数据并定位到过程记录 Tab
          const detailRes = await getRepairRequestDetail(reqId);
          if (detailRes.data && detailRes.data.success) {
            this.detailData = detailRes.data.response;
            this.detailActiveTab = 'process';
          }
        } else {
          this.$message.error((res.data && res.data.msg) || '上传失败');
        }
      } catch (err) {
        this.$message.error(err.message || '上传异常');
      } finally {
        this.processSubmitting = false;
      }
    }
  },

  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
      this.buttonList.unshift({ name: '查询', Func: 'handleQuery', id: 999 });
    }
    if (!this.buttonList.some(b => b.Func === 'handleExport')) {
      this.buttonList.push({ name: '导出', Func: 'handleExport', id: 998, icon: 'el-icon-download', btnType: 'success' });
    }
  }
};
</script>

<style scoped>
.repair-detail-loading {
  min-height: 120px;
}

.repair-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 14px;
  background: #f5f7fa;
  border-radius: 4px;
}

.repair-summary__type {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.repair-summary__loc {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.repair-meta-desc {
  margin-bottom: 12px;
}

.repair-flow-steps {
  margin-bottom: 14px;
}

.repair-reject-alert {
  margin-top: 12px;
}

.repair-detail-tabs >>> .el-tabs__content {
  max-height: 38vh;
  overflow-y: auto;
  padding-top: 4px;
}

.repair-material-text {
  display: block;
  line-height: 1.6;
  word-break: break-word;
  max-height: 4.8em;
  overflow: hidden;
}

.repair-material-text.is-expanded {
  max-height: none;
}

.repair-material-toggle {
  padding: 0;
  margin-top: 4px;
}

.repair-block {
  margin-bottom: 16px;
}

.repair-block:last-child {
  margin-bottom: 0;
}

.repair-block__title {
  margin-bottom: 8px;
  padding-left: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  border-left: 3px solid var(--btn-primary, #2563eb);
  line-height: 1.4;
}

.repair-dispatch-table {
  width: 100%;
}

.repair-img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.repair-img-item {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  overflow: hidden;
}

.repair-img-item >>> .el-image {
  width: 100%;
  height: 100%;
}

.repair-timeline {
  padding: 4px 0;
}

.repair-step-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
  color: #303133;
}

.repair-step-comment {
  margin: 6px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.repair-detail-empty {
  padding: 32px 0;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

.text-warning { color: #e6a23c; }
.text-success { color: #67c23a; }
.text-muted { color: #909399; }
.text-danger { color: #f56c6c; }

.repair-process-tab-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 4px;
}

.repair-process-count {
  font-size: 13px;
  color: #909399;
}

.repair-process-timeline-wrap {
  padding-top: 4px;
}

.repair-process-card {
  border-color: #ebeef5;
  background: #fafafa;
}

.repair-process-card >>> .el-card__body {
  padding: 10px 14px;
}

.repair-process-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.repair-process-author {
  font-weight: 600;
  font-size: 13px;
  color: #303133;
}

.repair-process-desc {
  margin: 0 0 8px;
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
  word-break: break-word;
}
</style>
